import { PublicReview } from '@shared/types';
import classNames from 'classnames';
import Link from 'next/link';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';

export type ExternalLinkProps = {
    className?: string;
    review: PublicReview;
};

const ExternalLink: FunctionComponent<ExternalLinkProps> = ({ className, review }) => {
    if (review.entity === 'course' || review.sourceKey === 'marketplace') {
        return null;
    }

    return (
        <div className={classNames(styles.link, className)}>
            Reviewed on{' '}
            <Link href={review.externalUrl} target="_blank" rel="noopener noreferrer">
                {review.sourceLabel}
            </Link>
        </div>
    );
};

export default ExternalLink;
